import { type ReactNode } from "react";
import { UserRoleContext, type UserRoleContextType } from "./user-role-context-type";

export type { UserRole, UserRoleContextType } from "./user-role-context-type";

type UserRoleProviderProps = {
  value: UserRoleContextType;
  children: ReactNode;
};

export function UserRoleProvider({ value, children }: UserRoleProviderProps) {
  return (
    <UserRoleContext.Provider value={value}>
      {children}
    </UserRoleContext.Provider>
  );
}

